import React, { lazy } from 'react';
import PrivateRoute from 'PrivateRoutes';
// import { Team, TeamManagement } from './components';
const Team = lazy(()=> import(/* webpackChunkName: "Team" */'./components/Team'));
const TeamManagement = lazy(()=> import(/* webpackChunkName: "TeamManagement" */'./components/TeamManagement'));

// const routes = () => <PrivateRoute exact path="/team" component={Team} />;

const editForm = ({ match }) => {
    return <TeamManagement mode="edit" teamId={match.params._id} />;
};


const routes = () => {
    return (
        <React.Fragment>
            <PrivateRoute exact path="/team" component={Team} />

            <PrivateRoute
                key="/team/edit"
                exact={true}
                path="/team/edit/:_id"
                component={editForm}
            />
        </React.Fragment>
    );
};

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/team/Team/routes.js